export default defineNuxtPlugin(async () => {
  const { fetchUser, isAuthenticated } = useAuth()

  // Solo se non è già autenticato, prova a ricaricare l'utente dal cookie
  if (!isAuthenticated.value) {
    try {
      await fetchUser()
    } catch {
      // Ignora errori, l'utente semplicemente non è loggato
    }
  }
})
